import React, { useMemo } from 'react';
import { FractureKey, ToothViewData } from './teethData';
import {
	Tooth,
	ToothFracturePosition,
	ToothFractureType,
} from '../../../../graphql/graphql';

interface Props {
	data: Tooth;
	toothViewData: ToothViewData;
}

const createFractureKey = (
	type: ToothFractureType,
	position: ToothFracturePosition,
): FractureKey => {
	return `${type},${position}`;
};

const DENTToothFractures: React.FC<Props> = ({ data, toothViewData }) => {
	const fractures = data.pathology?.fractures;

	if (!(fractures && fractures.length)) {
		return <></>;
	}

	const fractureKeys = useMemo(
		() =>
			fractures.flatMap(fracture =>
				fracture.positions.map(position =>
					createFractureKey(fracture.type, position),
				),
			),
		[fractures],
	);

	const toothFractureData = useMemo(
		() => fractureKeys.flatMap(key => toothViewData.fractures?.[key]),
		[fractureKeys, toothViewData.fractures],
	);

	return (
		<>
			{toothFractureData?.map((fracture, index) => (
				<polyline
					key={`fracture-${index}`}
					points={fracture}
					fill='none'
					stroke='rgba(255,0,0,0.6)'
					stroke-width='2'
				/>
			))}
		</>
	);
};

export default DENTToothFractures;
